export const TPA_EXPERIMENTS = {
  USE_BLOCKS_PLAN_LIST_WIDGET: 'specs.membership.UseBlocksPlanListWidget',
  USE_BLOCKS_PACKAGE_PICKER_PAGE: 'specs.membership.UseBlocksPackagePickerPage',
  INSTALL_SPLIT_PAGES: 'specs.membership.InstallSplitPages',
  ROUTER: 'specs.membership.EnableRouter',
  ROUTER_MIGRATION: 'specs.membership.RouterMigration',
  ROUTE_PAYWALL: 'specs.membership.RoutePaywall',
  SINGLE_PLAN_NEW_PRESETS_PANEL: 'specs.membership.SinglePlanNewPresetsPanel',
  FIX_STUDIO_BLOCKS_PLAN_CARD: 'specs.membership.FixStudioBlocksPlanCard',
  ROUTER_WITHOUT_PAGE_URI_SEO: 'specs.membership.RouterWithoutPageUriSeo'
};
//# sourceMappingURL=tpa.js.map